module.exports = __webpack_public_path__ + "resources/img/img_document_recognizer_txt_jp.86a0482142234ad372fc8425e939700f.png";